<template>
  <div class="main">
    <div class="main-controller">
      <div class="chart-wrapper">
        <div class="pointer" style="position:absolute;right:7%; top: 2%;" @click="openModal">
          <i class="fa fa-cog" style="color:red; font-size: large;"></i>
        </div>
        <div class="pointer" style="position:absolute;right:3%; top: 2%;" @click="downloadReport()">
          <i class="fa-solid fa-file-arrow-down" style="color:red;  font-size: large;"></i>
        </div>
        <div class="text-bold text-center">CSI Score</div>

        <div class="flex-row chart-container">
          <div class="left-chart">
            <div class="top-chart">
              <TopLeftChart />
            </div>
            <div class="bottom-chart">
              <BottomLeftChart />
            </div>
          </div>
          <div class="right-chart">
            <Chart />
          </div>
        </div>
        <p class="text-bold text-center">Keterangan: 9 Jam = 1 Hari</p>
      </div>
      <div class="card-wrapper">
        <Card :data="cardData" />
      </div>
    </div>
    <modal :isOpen="isModalOpen" @close="closeModal"></modal>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
import moment from 'moment'
export default {
  components: {
    TopLeftChart: () =>
      import('@/components/dashboard/main-kpi/csi-score/left/responden.vue'),
    BottomLeftChart: () =>
      import('@/components/dashboard/main-kpi/csi-score/left/puas.vue'),
    Chart: () =>
      import('@/components/dashboard/main-kpi/csi-score/left/right-chart.vue'),
    Modal: () => import('@/components/dashboard/main-kpi/modal-csi.vue'),
    Card: () => import('@/components/dashboard/main-kpi/right-card.vue'),
  },
  data() {
    return {
      isModalOpen: false,
      cardData: {
        tiketSelesai: 10,
        responden: 20,
        sistem: 20,
        belumNilai: 250,
        sedangProses: 20,
        rejected: 5,
      },
    }
  },
  methods: {
    openModal() {
      this.isModalOpen = true
    },
    closeModal() {
      this.isModalOpen = false
    },
    submitForm() {
      this.isModalOpen = false
    },
    async exportCsi(exportTitle, exportType) {
      let data = await this.$store.dispatch('kpiStore/exportData')

      let hideDataIds = data.map(i => {
        if (
          (i.status == 5 && i.type == 1 && i.tujuan_pendaftaran == 4) ||
          (i.status == 5 && i.type == 1 && i.tujuan_pendaftaran == 5)
        ) {
          return i.id
        }
      })

      // data = data.filter(i => !hideDataIds.includes(i.id))

      function whatStatus(status, type, tujuan_pendaftaran) {
        if (status == 5 && type == 2) {
          return 'Complete'
        }

        if (
          (status == 5 && type == 1 && tujuan_pendaftaran == 4) ||
          (status == 5 && type == 1 && tujuan_pendaftaran == 5)
        ) {
          return 'Complete'
        }

        if (status == 13 && type == 1) {
          return 'Complete'
        }

        return 'Not Complete'
      }

      function statusPenilaian(value) {
        if (
          (value.type == 2 && value.status == 5) ||
          (value.type == 1 && value.status == 13) ||
          (value.type == 1 && value.status == 5 && value.tujuan_pendaftaran == 4) ||
          (value.type == 1 && value.status == 5 && value.tujuan_pendaftaran == 5)
        ) {
          if (value.csi && value.csi != '') {
            if (value.note == 'penilaian oleh sistem') {
              return 'Sistem'
            }

            if (value.note == 'done') {
              return 'Responden'
            }
          }
        }

        return 'Belum di nilai'
      }

      const newData = data.map((item, index) => {
        let tujuan_daftar = ''
        if (item.tujuan_pendaftaran == 1) {
          tujuan_daftar = 'BIDDING/SOURCING (ARIBA ONLY)'
        }
        if (item.tujuan_pendaftaran == 2) {
          tujuan_daftar = 'PENERBITAN PO DARI PROCUREMENT'
        }
        if (item.tujuan_pendaftaran == 3) {
          tujuan_daftar = 'PENERBITAN PO DARI INTERNAL DEPT'
        }
        if (item.tujuan_pendaftaran == 4) {
          tujuan_daftar = 'PEMBAYARAN BUYER & DEMURRAGE'
        }
        if (item.tujuan_pendaftaran == 5) {
          tujuan_daftar = 'PEMBAYARAN DONASI & CSR'
        }

        const newDataItem = {
          no: index + 1,
          no_ticket: item.code,
          type_request: this.requestType(item.type),
          tujuan_pendaftaran: tujuan_daftar,
          nama_vendor: item.nama_vendor,
          requestor: item.user,
          pic: "",
          last_status: this.requestStatus(item.status),
          status: whatStatus(item.status, item.type, item.tujuan_pendaftaran),
          csi: item.csi,
          note: statusPenilaian(item),
        }

        item.approval.forEach((approval, index) => {
          if (item.type == 1 && item.status == 13) {
            if (approval.status == 5) {
              newDataItem['pic'] =
                approval && approval.approver && approval.approver.name
            }
          } else if (item.status == 4) {
            if (approval.status == 4) {
              newDataItem['pic'] =
                approval && approval.approver && approval.approver.name
            }
          } else if (item.status == 11) {
            if (approval.status == 11) {
              newDataItem['pic'] =
                approval && approval.approver && approval.approver.name
            }
          } else if (item.type == 2 && item.status == 5) {
            if (approval.status == 9) {
              newDataItem['pic'] =
                approval && approval.approver && approval.approver.name
            }
          } else {
            if (item.type == 1) {
              if (
                item.tujuan_pendaftaran == 4 ||
                item.tujuan_pendaftaran == 5
              ) {
                if (approval.status == 9) {
                  newDataItem['pic'] =
                    approval && approval.approver && approval.approver.name
                }
              } else {
                if (approval.status == 5) {
                  newDataItem['pic'] =
                    approval && approval.approver && approval.approver.name
                }
              }
            } else {
              if (approval.status == 9) {
                newDataItem['pic'] =
                  approval && approval.approver && approval.approver.name
              }
            }
          }
        })
        return newDataItem
      })

      const totalComplate = newData.filter(i => i.status == 'Complete').length
      const csiHasValue = newData.filter(i => i.csi && i.csi != '').length
      const avgCsi = newData.reduce((a, b) => {
        return a + Number(b && b.csi && b.csi != '' ? b.csi : 0)
      }, 0)
      const statusDone = newData.filter(
        i => i.note == 'Responden' || i.note == 'Sistem'
      ).length

      newData.push({
        no: 'Total',
        no_ticket: this.countUniqueNames(newData, 'no_ticket'),
        type_request: '',
        tujuan_pendaftaran: '',
        nama_vendor: '',
        requestor: this.countUniqueNames(newData, 'requestor'),
        pic: '',
        last_status: '',
        status: totalComplate,
        csi: Math.round(avgCsi / csiHasValue),
        note: statusDone,
      })

      newData.unshift({})

      let start = this.$store.state.kpiStore.start
      let end = this.$store.state.kpiStore.end

      let wb = XLSX.utils.book_new()
      let sheet = [exportTitle]
      sheet.forEach(list => {
        let dataToExport = XLSX.utils.json_to_sheet(newData)
        const title = [
          ['', '', '', '', '', '', '', '', '', '', ''],
          [
            'No',
            'Ticket Number',
            'Type Request',
            'Tujuan Pendaftaran',
            'Nama Vendor',
            'Requestor',
            'PIC SIPM',
            'Last Status',
            'Status',
            'CSI',
            'Penilaian',
          ],
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `${exportTitle}.xlsx`)
    },
    downloadReport() {
      this.exportCsi('DB CSI', 'CSI')
    },
  },
}
</script>

<style scoped>
.main {
  /* width: 85vw; */
  width: 80vw;
  background-color: pink;
  overflow: auto;
}

.main-controller {
  padding: 10px;
  height: 78vh;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
}

.chart-wrapper {
  width: 75%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: -6px 5px 8px 0 rgba(0, 0, 0, 0.2);
  background-color: white;
  /* gap: 0.5rem; */
  padding: 1rem 0;
  position: relative;
}

.chart-container {
  justify-content: center;
}

.left-chart,
.right-chart {
  padding: 1rem 1rem;
}

.left-chart {
  width: 35%;
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.right-chart {
  /* width: 55%; */
  /* border: 1px solid blue; */
}

.card-wrapper {
  width: 25%;
}
</style>
